import React from 'react';
import Modal from 'react-bootstrap/Modal';
// import Moment from 'react-moment';
// import 'moment-timezone';
// import {dirname, basename} from '../../utils/commonUtilities'; 
import { getUserTimeZone, userGroupUrlCheck } from '../../utils/userGroupUrlCheck';
import { converDateToLocal } from '../../utils/commonUtilities';
import { checkPermissions } from '../../utils/permissions';
// import AWS from 'aws-sdk'; 
// import {AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_STORAGE_BUCKET_NAME, AWS_STORAGE_PDF_FOLDER} from '../../configs/awsConfigs'; 
import { LBL_NOT_GENERATED, LBL_SEND_INVOICE, LBL_RESEND_INVOICE, LBL_CONFIM_TO_REGEN_INVOICE, LBL_INVOICE_NUMBER, LBL_SEND_UPDATED_INVOICE, LBL_EVENT_PREFIX, LBL_SHIFT_PREFIX, LBL_QUOTE, LBL_CLIENT, LBL_PO, LBL_CREW, LBL_CHIEF, LBL_AFFILIATE, LBL_CREW_CHIEF, LBL_TOTAL, LBL_HOURS_SHORT, LBL_SUB_TOTAL, LBL_VAT, LBL_BANK_ACC_DET, LBL_CONTACT, LBL_DISCOUNT, LBL_REQUEST_BY, LBL_STAFF_PER_VEHICLE, LBL_NO_OF_VEHICLES, LBL_DISTANCE_TO_LOCATION, LBL_TRAVEL_COST, LBL_TRAVEL_TIME, LBL_TRAVEL_COST_TOTAL, LBL_MILES, LBL_SHIFT_TOTAL, LBL_SLNUM, LBL_TM_FIELD_NAME, LBL_NUM_PASSENGERS, LBL_RATE, LBL_DISTANCE, LBL_RETURN_COST_INCLUDED, LBL_MINS_SHORT, } from '../../configs/labelConfigs';
// LBL_CREWS, LBL_CHIEFS, LBL_TIME_ZONE, LBL_ISSUE_DATE, LBL_MODIFIED_DATE,LBL_QUOTE_VALID_UNTIL, LBL_REQUEST, LBL_ACCEPT, LBL_REJECT, LBL_SEND_TO,
import { MSG_CONFIRM_REGEN_INVOICE } from '../../configs/msgConfigs';

import { EVENT_STATUS_CANCELLED, SHIFT_STATUS_CANCELLED, DISCOUNT_TYPE_PERCENTAGE, TM_FIELD_DISTANCE_ID, TM_FIELD_TIME_ID, TM_FIELD_PSNGR_COUNT_ID, TM_FIELD_FLAT_AMOUNT_ID  } from '../../configs/staticConfigs';

import { showSendQuoteBtn, showRequestQuoteBtn, showAcceptRejectQuoteBtn, showAcceptRejectQuoteBtnAflt } from './eventStatusCheck';
import { convertDecimalToHHMM } from '../../utils/commonUtilities';
import ModalWindow from '../commons/helpers/modalWindow';

class PreviewInvoice extends React.Component {

    constructor(props) {
        super()
        this.state = {
            showModal: false
        }
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleModelClose = this.handleModelClose.bind(this);

        this.modalConfirmation = React.createRef();
    }


    handleOpenModal = () => {
        this.setState({
            showModal: true
        });
    }

    handleModelClose = () => {
        this.setState({
            showModal: false
        }, () => {
        });
    }
    sendInvoice = () => {
        this.modalConfirmation.current.handleModelClose();
        this.handleModelClose();
        this.props.saveFormData();
    }

    onModalFormReset = () => {

    }
    openConfirmation = () => {
        this.modalConfirmation.current.handleOpenModal();
    }
    getFieldRate = (affiliateFields, fieldId) => {
        const field = affiliateFields.find(f => f.field_id === fieldId);
        return field ? field.field_rate : '';
    };

    getFieldName = (affiliateFields, fieldId) => {
      const field = affiliateFields.find(f => f.field_id === fieldId);
      return field ? field.field_name : '';
    };

         formatDecimalToHHMM = (decimal) => {
        if (decimal === null || decimal === undefined || decimal === '') return "00:00";

        const [h, m] = decimal.toString().split(".");
        const hours = h.padStart(2, '0');
        const minutes = m ? m.padStart(2, '0') : '00';

        return `${hours}:${minutes}`;
    };
    
    render() {

        const { eventPreviewQuote, isClientPage } = this.props;
        const userCurrency = this.props.profileCurrency;

        let eventId = '';
        let poNumber = '';
        let invoiceNumber = '';
        let quoteNumber = '';
        let affCompanyName = '';
        let affCompanyPhone = '';
        let affCompanyWebsite = '';
        let affCompanyEmail = '';
        let affCompanyLogo = '';
        let affLocation = '';
        let affAdditionalText = '';
        let requestedBy = '';

        let affDynamicFields = [];
        let clientName = '';
        let clientContact = '';
        let clientVenue = '';
        let clientStreetOne = '';
        let clientStreetTwo = '';
        let clientCity = '';
        let clientState = '';
        let clientCountry = '';
        let clientPostcode = '';
        let clientPhone = '';
        let eventTitle = '';
        let eventNumber = '';
        let eventLocationId = 0;
        let eventLocation = '';
        let eventStartDTime = '';
        let eventEndDTime = '';
        let eventReqCrews = 0;
        let eventReqChiefs = 0;
        let eventCancelled = '';
        let addtionFields = '';
        // let eventVenue = '';
        // let eventStreetOne = '';
        // let eventStreetTwo = '';
        // let eventCity = '';
        // let eventState= '';
        // let eventCountry= '';
        // let eventPostcode= '';

        let shiftdata = [];
        let subTotal = '';
        let overallTotal = '';
        let discountCost = 0;
        let quoteDiscountType = '';
        let quoteDiscountPerc = 0;
        let vatCost = '';
        let eventQuoteStatus = 0;
        let eventStatus = 0;
        let showSendQuote = false;
        let showRequestQuote = false;
        let showAcceptQuote = 0;
        let showRejectQuote = 0;
        let isAffiliateCanAcceptQuote = true; // IF PERMISSION COMES SET THIS VARIABLE ACCORDING TO IT 
        let canAcceptQuote = isClientPage ? true : isAffiliateCanAcceptQuote;


        let timeZone = getUserTimeZone(window.location);

        let userGroupData = userGroupUrlCheck(window.location);
        let supervisor_name = '';
        let crew_chief = '';
        if (userGroupData !== undefined) {
            supervisor_name = userGroupData.supervisor_name
            crew_chief = userGroupData.supervisor_name
        }
        if (!supervisor_name) {
            supervisor_name = LBL_CHIEF;
            crew_chief = LBL_CREW_CHIEF;
        }

        let is_active = this.props.hasOwnProperty('is_active') ? this.props.is_active : true;
        let issueDate = '';
        let modifiedDate = '';
        let validUntilDate = '';
        let timeZoneName = timeZone.region;
        let isViewAcceptQuote = is_active === true && checkPermissions("acceptquote", "view");
        let signature = '';
        let signatureUrl = '';
        let poOrSign = false;
        if (Object.keys(eventPreviewQuote).length > 0) {
            eventId = eventPreviewQuote.id;

            if (eventPreviewQuote.hasOwnProperty('quote_set') && Array.isArray(eventPreviewQuote.quote_set)) {
                let quote_set = eventPreviewQuote.quote_set[0];
                if (quote_set.valid_until && quote_set.valid_until.trim().length > 0) validUntilDate = converDateToLocal(quote_set.valid_until, timeZone.utc_offset, 'ddmmyyyyhhmm');
                if (quote_set.quote_sent_datetime && quote_set.quote_sent_datetime.trim().length > 0) issueDate = converDateToLocal(quote_set.quote_sent_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
                if (quote_set.quote_re_sent_datetime && quote_set.quote_re_sent_datetime.trim().length > 0 && quote_set.quote_sent_datetime !== quote_set.quote_re_sent_datetime) modifiedDate = converDateToLocal(quote_set.quote_re_sent_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
            }

            poNumber = eventPreviewQuote.po_number === null ? '' : eventPreviewQuote.po_number;
            signatureUrl = eventPreviewQuote.signature === null ? '' : eventPreviewQuote.signature;

            if (poNumber.length > 0) {
                poOrSign = true;
            }

            if (signatureUrl.length > 0) {
                poOrSign = true;
            }

            quoteNumber = eventPreviewQuote.quote_number;
            let affDynamicFieldsFilter = [];
            if (eventPreviewQuote.affiliate_profile) {
                affCompanyName = eventPreviewQuote.affiliate_profile.company_name;
                affCompanyPhone = eventPreviewQuote.affiliate_profile.phone_number;
                affCompanyWebsite = eventPreviewQuote.affiliate_profile.web_site;
                affCompanyEmail = eventPreviewQuote.affiliate_profile.company_email;
                affCompanyLogo = eventPreviewQuote.affiliate_profile.logo;
                if (eventPreviewQuote.affiliate_profile.location !== null) {
                    affLocation = eventPreviewQuote.affiliate_profile.location.location;
                    affDynamicFieldsFilter = eventPreviewQuote.affiliate_profile.dynamic_fields.filter(x => x !== null);
                }
                if (eventPreviewQuote.affiliate_profile.additional_text !== null) {
                    affAdditionalText = eventPreviewQuote.affiliate_profile.additional_text;
                }
            }

            requestedBy = eventPreviewQuote.requested_by;

            if (affDynamicFieldsFilter.length > 0) {
                affDynamicFieldsFilter[0].field_details.forEach((item) => {
                    if ((item.value) && item.value.trim()) affDynamicFields.push(item);
                })
            }

            let clientUsers = [];
            if (eventPreviewQuote.client_profile) {
                if (eventPreviewQuote.client_contact && eventPreviewQuote.client_contact.length > 0) {
                    clientContact = eventPreviewQuote.client_contact;
                }
                else {
                    clientUsers = eventPreviewQuote.client_profile.associateusers_set.filter(x => x !== null);
                    if (clientUsers.length > 0) {
                        clientContact = clientUsers[0].user.first_name + ' ' + clientUsers[0].user.last_name;
                    }
                }

                clientName = eventPreviewQuote.client_profile.company_name;
                // clientPhone = eventPreviewQuote.client_profile.phone_number
                clientPhone = eventPreviewQuote.client_phone_number;
                if (eventPreviewQuote.client_profile.location !== null) {
                    clientVenue = (eventPreviewQuote.client_profile.location.venue) ? (eventPreviewQuote.client_profile.location.venue) : '';
                    clientStreetOne = (eventPreviewQuote.client_profile.location.street1) ? (eventPreviewQuote.client_profile.location.street1) : '';
                    clientStreetTwo = (eventPreviewQuote.client_profile.location.street2) ? eventPreviewQuote.client_profile.location.street2 : '';
                    clientCity = (eventPreviewQuote.client_profile.location.city) ? eventPreviewQuote.client_profile.location.city : '';
                    clientState = (eventPreviewQuote.client_profile.location.state) ? eventPreviewQuote.client_profile.location.state : '';
                    clientCountry = (eventPreviewQuote.client_profile.location.country) ? eventPreviewQuote.client_profile.location.country : '';
                    clientPostcode = (eventPreviewQuote.client_profile.location.postcode) ? eventPreviewQuote.client_profile.location.postcode : '';
                }
            }

            eventTitle = eventPreviewQuote.title;
            eventCancelled = Number(eventPreviewQuote.status) === Number(EVENT_STATUS_CANCELLED) ? ' (Cancelled)' : '';

            eventNumber = eventPreviewQuote.event_number === null ? '' : eventPreviewQuote.event_number;
            let filteredShift = [];
            if (eventPreviewQuote.shift_set) {
                filteredShift = eventPreviewQuote.shift_set.filter((data) => data != null);
            }

            if (eventPreviewQuote.location) {
                eventLocationId = eventPreviewQuote.location.location.id;
                eventLocation = eventPreviewQuote.location.location.location;
            }

            // eventStartDTime     = eventPreviewQuote.start_date;
            // eventEndDTime       = eventPreviewQuote.end_date;
            eventStartDTime = converDateToLocal(eventPreviewQuote.start_date, "+00:00", 'ddmmyyyy');
            eventEndDTime = converDateToLocal(eventPreviewQuote.end_date, "+00:00", 'ddmmyyyy');
            eventReqCrews = eventPreviewQuote.required_crews;
            eventReqChiefs = eventPreviewQuote.required_chiefs;

            shiftdata = filteredShift;
            let shiftCount = shiftdata.length;

            subTotal = eventPreviewQuote.total_cost;
            overallTotal = eventPreviewQuote.total;
            discountCost = eventPreviewQuote.discount_cost ? eventPreviewQuote.discount_cost : 0;
            quoteDiscountType = eventPreviewQuote?.discount_type ? eventPreviewQuote?.discount_type : '';
            quoteDiscountPerc = eventPreviewQuote?.discount_percentage ? eventPreviewQuote.discount_percentage : 0;
            vatCost = eventPreviewQuote.vat_cost;
            eventStatus = eventPreviewQuote.status;
            // let vatPer = eventPreviewQuote.vat?Number(eventPreviewQuote.vat):0;
            // let addtionalCost = 0.0;
            // let currentTotal = subTotal; 
            // console.log(subTotal);

            // this.props.additionalValues.map((item,index)=>{
            //     let vari = 1;
            //     if(item.type==='discount')vari=-1
            //     addtionalCost = addtionalCost +(Number(item.amount)*vari);
            // });
            // currentTotal = currentTotal - Number(discountCost);
            // currentTotal = Number(currentTotal)+addtionalCost;
            // // subTotal = currentTotal;
            // if(vatPer>0){
            //     vatCost = parseFloat((currentTotal*vatPer)/100);

            //     currentTotal = currentTotal+vatCost;
            // }
            // overallTotal = parseFloat(currentTotal).toFixed(2);
            // vatCost = parseFloat(vatCost).toFixed(2);
            // subTotal = parseFloat(subTotal).toFixed(2);

            if (eventPreviewQuote.quote_set && eventPreviewQuote.quote_set.length > 0) {
                eventQuoteStatus = eventPreviewQuote.quote_set[0].quote_status;
                showSendQuote = is_active === true && showSendQuoteBtn(isClientPage, eventQuoteStatus, quoteNumber, shiftCount, eventStatus);

                // FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020
                if (!isClientPage) showAcceptQuote = showAcceptRejectQuoteBtnAflt(canAcceptQuote, eventStatus, eventQuoteStatus);
                else showAcceptQuote = is_active === true && showAcceptRejectQuoteBtn(canAcceptQuote, eventStatus, eventQuoteStatus);

                showRejectQuote = is_active === true && showAcceptRejectQuoteBtn(isClientPage, eventStatus, eventQuoteStatus);
                showRequestQuote = is_active === true && showRequestQuoteBtn(isClientPage, eventStatus, eventQuoteStatus);
                signature = eventPreviewQuote.quote_set[0].signature_url;

            }
            if (eventPreviewQuote.invoice_data) {
                invoiceNumber = eventPreviewQuote.invoice_data.invoice_number
                let arr_invoice_number = invoiceNumber.split('-');
                arr_invoice_number[arr_invoice_number.length - 1] = Number(arr_invoice_number[arr_invoice_number.length - 1]) + 1
                invoiceNumber = arr_invoice_number.join('-');
            }

            if (this.props.additionalValues.length > 0) {
                this.props.additionalValues.map((item, index) => {
                    let discount = '';
                    let amount = 0.0;
                    amount = parseFloat(Number(item.amount)).toFixed(2)
                    if (item.type === 'discount') discount = '-';
                    addtionFields = <p className='pb-2 pr-2'>{item.description} &emsp; &emsp; {discount}{userCurrency} {amount}</p>
                })
            }
        }

        return (
            <React.Fragment>
                <Modal show={this.state.showModal} id={this.props.modalId}  >
                    <Modal.Header closeButton={false} className="preview-quote">


                        <button type="button" className="print-button client-btn width-190" onClick={this.openConfirmation}>{LBL_SEND_UPDATED_INVOICE}</button>
                        <button type="button" className="print-button client-btn width-175" onClick={this.props.sendOldInvoice}>{eventPreviewQuote && eventPreviewQuote?.bot_sent_invoice ? LBL_RESEND_INVOICE : LBL_SEND_INVOICE}</button>

                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleModelClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="preview-quote">
                        <div className="row quote-head">
                            <div className="col-6">
                                <img alt="company-logo" src={affCompanyLogo} className={affCompanyLogo === null ? 'hide' : 'img-fliud'} />
                                <h2 className="crew"> &nbsp; {affCompanyName}</h2>
                            </div>
                            <div className="col-6">
                                <h2 className="quote-no"><span className="textNoBold">{LBL_QUOTE} No : </span>{quoteNumber}</h2>
                            </div>

                        </div>
                        <div className="row qaddress mt-20 border-One">
                            <div className="col-6">
                                <p>To,</p>
                                <p>&emsp; {clientName} </p>
                                {(clientVenue) && clientVenue.trim().length > 0 && <p>&emsp; {clientVenue}</p>}
                                {(clientStreetOne) && clientStreetOne.trim().length > 0 && <p>&emsp; {clientStreetOne}</p>}
                                {(clientStreetTwo) && clientStreetTwo.trim().length > 0 && <p>&emsp; {clientStreetTwo}</p>}
                                {(clientCity) && clientCity.trim().length > 0 && <p>&emsp; {clientCity}</p>}
                                {(clientState) && clientState.trim().length > 0 && <p>&emsp; {clientState}</p>}
                                {(clientCountry) && clientCountry.trim().length > 0 && <p>&emsp; {clientCountry}</p>}
                                {(clientPostcode) && clientPostcode.trim().length > 0 && <p>&emsp; {clientPostcode}</p>}
                                {(clientPhone) && clientPhone.trim().length > 0 && <><p>&nbsp;</p><p>&emsp; Tel : <span className="text-bold">{clientPhone}</span></p></>}
                            </div>
                            <div className="col-6 text-right ">
                                <p>&nbsp;</p>
                                {/* {(issueDate) && issueDate.trim().length > 0 && <p> Issue Date : <span className="text-bold"><Moment format="DD/MM/YYYY">{new Date(issueDate)}</Moment></span></p>}  
                    (validUntilDate) && validUntilDate.trim().length > 0 && <p> {LBL_QUOTE} Valid Until : <span className="text-bold"> <Moment format="DD/MM/YYYY">{new Date(validUntilDate)}</Moment></span></p>}  */}

                                {/*{(issueDate) && issueDate.trim().length > 0 && <p> {LBL_ISSUE_DATE}: <span className="text-bold">{issueDate}</span></p>} 
                    {(modifiedDate) && modifiedDate.trim().length > 0 && <p> {LBL_MODIFIED_DATE}: <span className="text-bold">{modifiedDate}</span></p>}
                    {(validUntilDate) && validUntilDate.trim().length > 0 && <p> {LBL_QUOTE_VALID_UNTIL}: <span className="text-bold"> {validUntilDate}</span></p>} 
                    {(issueDate) && issueDate.trim().length > 0 && (timeZoneName) && timeZoneName.trim().length > 0 && <p><small> {LBL_TIME_ZONE}: <span className="text-bold">{timeZoneName}</span></small></p>}
                    {(poNumber) && String(poNumber).trim().length > 0 && <p> {LBL_PO}: <span className="text-bold"> {poNumber}</span></p>}*/}

                                {(issueDate) && issueDate.trim().length > 0 && <p>&nbsp;</p>}
                                {(invoiceNumber) && String(invoiceNumber).trim().length > 0 && <p> {LBL_INVOICE_NUMBER}: <span className="text-bold"> {invoiceNumber}</span></p>}
                                {/* {(!invoiceNumber) || String(invoiceNumber).trim().length===0 && <p> {LBL_INVOICE_NUMBER}: <span className="text-bold"> {LBL_NOT_GENERATED}</span></p>} */}

                                {(poNumber) && String(poNumber).trim().length > 0 && <p> {LBL_PO}: <span className="text-bold"> {poNumber}</span></p>}
                                {(requestedBy) && requestedBy.trim().length > 0 && <p> {LBL_REQUEST_BY + ':'} <span className="text-bold"> {requestedBy}</span></p>}
                                {(clientContact) && clientContact.trim().length > 0 && <p> {LBL_CLIENT} Contact: <span className="text-bold">  {clientContact}</span></p>}
                            </div>
                        </div>

                        <div className="row preview-quote mt-10 border-OneGrey">
                            <div className="col-12">
                                <p className="line-height-15"><div className="line-height-15"><span className="text-bold">{eventTitle}</span> &nbsp; {LBL_EVENT_PREFIX + '' + eventNumber} <span className="text-bold">{eventCancelled}</span><br></br>
                                    <small>{eventLocation}</small></div>
                                </p>
                                {/* <p><small>{eventLocation}</small></p> */}

                                {/* {(eventStartDTime) && eventStartDTime.trim().length > 0 && <p className="paddingTop6"><Moment format="DD/MM/YYYY hh:mm">{new Date(eventStartDTime)}</Moment> - <Moment format="DD/MM/YYYY hh:mm">{new Date(eventEndDTime)}</Moment><small></small></p>}  */}
                                {(eventStartDTime) && eventStartDTime.trim().length > 0 && <p className="paddingTop6">{eventStartDTime + ' - ' + eventEndDTime}</p>}

                                {/* {Number(eventReqCrews) > 0 && <p className="paddingTop6">{LBL_TOTAL+' '+LBL_CREWS+'/'+LBL_CHIEFS} : <span className="text-bold"> {eventReqCrews+'/'+eventReqChiefs}</span><small></small></p>}           */}
                            </div>
                        </div>

                        {shiftdata.map((item, index) => {
                            let total = item.total;
                            let start_datetime = converDateToLocal(item.start_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
                            let end_datetime = converDateToLocal(item.end_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
                            let required_chiefs = Number(item.required_chiefs);
                            let crew_chief_bonus = Number(item.crew_chief_bonus);
                            let chief_bonus_total = Number(item.chief_bonus_total);
                            if (required_chiefs > 0) crew_chief_bonus = parseFloat(chief_bonus_total) / required_chiefs;
                            let shift_length = convertDecimalToHHMM(item.shift_length);
                            let shiftCancelled = Number(item.status) === Number(SHIFT_STATUS_CANCELLED) ? ' (Cancelled)' : '';

                            // TRAVEL COST - SINGLE FIELD ONLY SETTINGS 
                            const travelCostDetails = item.travel_cost_details;
                            let tcSnglFldShowTravelTime = true, tcSnglFldShowTravelDistance = true;
                            let tcSnglFldShowCalcField = true, tcSnglFldFieldSuffix = '', tcSnglFldCalcFieldName = '', tcSnglFldCalcFieldUnit = '', tcSnglFldCalcFieldValue = '';  

                            if(Object.keys(travelCostDetails).length > 0 && travelCostDetails?.travel_fields.length===1) {
                                if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_DISTANCE_ID) {
                                    tcSnglFldShowTravelDistance = false;
                                    tcSnglFldCalcFieldName = LBL_DISTANCE_TO_LOCATION; 
                                    tcSnglFldCalcFieldUnit = ' ('+LBL_MILES+')'; 
                                    tcSnglFldCalcFieldValue = travelCostDetails?.travel_distance_miles; 
                                } else if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_TIME_ID) {
                                    tcSnglFldShowTravelTime = false; 
                                    tcSnglFldCalcFieldName = LBL_TRAVEL_TIME; 
                                    tcSnglFldCalcFieldUnit = ' ('+LBL_HOURS_SHORT+')';
                                    tcSnglFldCalcFieldValue = travelCostDetails?.travel_duration_hh_mm; 
                                } 
                                else if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_PSNGR_COUNT_ID) {
                                    tcSnglFldCalcFieldName = LBL_STAFF_PER_VEHICLE; 
                                    tcSnglFldCalcFieldUnit = ''; 
                                    tcSnglFldCalcFieldValue = 'staffCount'; 
                                } else if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
                                    tcSnglFldShowCalcField = false; 
                                    tcSnglFldCalcFieldName = ''; 
                                    tcSnglFldCalcFieldUnit = ''; 
                                    tcSnglFldFieldSuffix = ' ('+userCurrency+')';
                                }
                            }

                            // TRAVEL COST - MULTIPLE FIELDS SETTINGS 
                            let tcMultiColSpanValue = 0; 
                            let tcMultiFldShowTravelTime = false, tcMultiFldShowTravelDistance = false, tcMultiFldShowNumPassenger = false;
                            if(Object.keys(travelCostDetails).length > 0 && travelCostDetails?.travel_fields.length > 1) {
                                travelCostDetails.travel_fields.map(tfItem => { 
                                    if(Number(tfItem.field_type)===TM_FIELD_DISTANCE_ID) {
                                        tcMultiFldShowTravelDistance = true;
                                        tcMultiColSpanValue++;
                                    } else if(Number(tfItem.field_type)===TM_FIELD_TIME_ID) {
                                        tcMultiFldShowTravelTime = true; 
                                        tcMultiColSpanValue++;
                                    } 
                                    else if(Number(tfItem.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
                                        tcMultiFldShowNumPassenger = true; 
                                        tcMultiColSpanValue++; 
                                    } 
                                    // else if(Number(tfItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
                                        
                                    // }
                                })
                            }

                            return (
                                <React.Fragment key={index}>
                                    <div className="row preview-quote mt-10 border-TopBottom">
                                        <div className="col-6">
                                            <p className="line-height-15"><div className="line-height-15"><span className="text-bold">{item.title}</span> &nbsp; {LBL_SHIFT_PREFIX + '' + item.shift_number} <span className="text-bold">{shiftCancelled}</span>
                                                {(Number(eventLocationId) !== Number(item.shift_location.location.id)) && <div className="widthPerc80"><small>{item.shift_location.location.location}</small></div>}</div></p>
                                            {/* {(item.start_datetime) && item.start_datetime.trim().length > 0 && <p> <Moment format="DD/MM/YYYY hh:mm">{new Date(item.start_datetime)}</Moment> - <Moment format="DD/MM/YYYY hh:mm">{new Date(item.end_datetime)}</Moment><small></small></p>} */}
                                            {(start_datetime) && start_datetime.trim().length > 0 && <p> {start_datetime + ' - ' + end_datetime}</p>}
                                        </div>
                                        <div className="col-6 text-right">
                                            {(item.affiliate_contact) && item.affiliate_contact.trim().length > 0 && <p>{LBL_AFFILIATE + ' ' + LBL_CONTACT} : <span className="text-bold"> {item.affiliate_contact}</span><small></small></p>}
                                            {(item.client_contact) && item.client_contact.trim().length > 0 && <p>{LBL_CLIENT + ' ' + LBL_CONTACT} : <span className="text-bold"> {item.client_contact}</span><small></small></p>}

                                            {/* {Number(item.required_crews) > 0 && <p>{LBL_TOTAL+' '+LBL_CREWS+'/'+LBL_CHIEFS} : <span className="text-bold"> {item.required_crews+'/'+item.required_chiefs}</span><small></small></p>}   */}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <table className="table">
                                            <tbody>
                                                {item.shift_skills.map((sk, i) => {
                                                    let skillHours = convertDecimalToHHMM(sk.hour);
                                                    return (
                                                        <tr key={i}>
                                                            <td className="width-40-percent text-left">{sk.count + ' x ' + sk.skill.skill_name}</td>
                                                            <td className="width-25-percent text-right">{userCurrency + ' ' + sk.charge_rate + '/' + LBL_CREW}</td>
                                                            <td className="width-15-percent text-right">{skillHours + ' ' + LBL_HOURS_SHORT.toLowerCase()}</td>
                                                            <td className="width-20-percent text-right">{userCurrency + ' ' + (sk.charge_rate_total)}</td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                                {required_chiefs > 0 && <tr>
                                                    <td className="width-40-percent text-left">{required_chiefs + ' x ' + crew_chief}</td>
                                                    <td className="width-25-percent text-right">{userCurrency + ' ' + crew_chief_bonus.toFixed(2) + '/' + supervisor_name}</td>
                                                    <td className="width-15-percent text-right">{shift_length + ' ' + LBL_HOURS_SHORT.toLowerCase()}</td>
                                                    <td className="width-20-percent text-right">{userCurrency + ' ' + chief_bonus_total.toFixed(2)}</td>
                                                </tr>
                                                }

                                                {item.expenses.map((other, o) => {
                                                    return (
                                                        <tr key={o}>
                                                            <td className="width-40-percent text-left">{other.other_expense.name}</td>
                                                            <td className="width-25-percent text-right"></td>
                                                            <td className="width-15-percent text-right"></td>
                                                            <td className="width-20-percent text-right">{userCurrency + ' ' + other.cost}</td>
                                                        </tr>
                                                    )
                                                })
                                                }

                                                {item.shift_skills && (item.shift_skills.length >= 1) && item?.discount && parseFloat(item.discount) > 0 ?
                                                    <>
                                                        <tr className="head">
                                                            <td colSpan="3" className="text-left text-bold"><b>{LBL_SUB_TOTAL}</b></td>
                                                            <td className="width-20-percent text-right text-bold"><b>{userCurrency + " "}{(parseFloat(item.sub_total)).toFixed(2)}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3" className="text-left text-bold"><b>{LBL_DISCOUNT + (item?.discount_percentage ? (' (' + item.discount_percentage + '%)') : '')}</b></td>
                                                            <td className="width-20-percent text-right text-bold"><b>{userCurrency + " "}{(parseFloat(item.discount)).toFixed(2)}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="row" colSpan="3" className="total pl-3 text-bold text-left">
                                                                <span className="text-bold">{LBL_TOTAL}:</span>
                                                            </td>
                                                            <td className="total text-right  text-bold">
                                                                <span className="text-bold">
                                                                    {userCurrency + " " + total}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </>
                                                    :
                                                    <></>
                                                }


                                                {item.shift_skills && (item.shift_skills.length >= 1) && item?.discount && parseFloat(item.discount) == 0 ?
                                                    <>
                                                        <tr>
                                                            <td scope="row" colSpan="3" className="total pl-3 text-bold text-left"><span className="text-bold">{LBL_TOTAL}:</span></td>
                                                            <td className="total text-right  text-bold"><span className="text-bold">{userCurrency + ' ' + total}</span></td>
                                                        </tr>
                                                    </>
                                                    : <></>
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {Object.keys(item.travel_cost_details).length === 0 ? null : (
                                        <>
                                        {travelCostDetails?.travel_fields.length===1 ? <>
                                            <div className="row bgWhite" >
                                                <table className="table mt-3 bgWhite" > 
                                                    <thead className="bgWhite" >
                                                        <tr className="border-bottom bgWhite" >
                                                            <th colSpan={5} className="bgWhite">
                                                            <div className='d-flex justify-content-between align-items-center w-100 font-14 bgWhite' >
                                                                <div className='text-bold'>{LBL_TRAVEL_COST} {travelCostDetails.travel_return_cost_included ? LBL_RETURN_COST_INCLUDED : ''} </div>
                                                                {tcSnglFldShowTravelDistance ? <div className='text-normal'>{LBL_DISTANCE_TO_LOCATION}: {parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)} {LBL_MILES}</div> : <></>}
                                                                {tcSnglFldShowTravelTime ? <div className='text-normal'>{LBL_TRAVEL_TIME}: {this.formatDecimalToHHMM(travelCostDetails.travel_duration_hh_mm)} {" (" +LBL_HOURS_SHORT +":" +LBL_MINS_SHORT +")"}  </div> : <></>}
                                                            </div>
                                                            </th>
                                                        </tr>
                                                        <tr className="border-bottom bgWhite" >
                                                            <th className="bgWhite">{LBL_SLNUM}</th>
                                                            <th className=" text-right bgWhite" >{travelCostDetails.travel_fields[0].field_name+tcSnglFldFieldSuffix}</th>
                                                            <th className=" text-right bgWhite" >{tcSnglFldShowCalcField ? <>{tcSnglFldCalcFieldName} <span className='text-normal'>{tcSnglFldCalcFieldUnit}</span></> : <></>}</th> 
                                                            <th className=" text-right bgWhite" >{LBL_NO_OF_VEHICLES}</th>
                                                            <th className=" text-right bgWhite" >{LBL_TOTAL} ({userCurrency})</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {travelCostDetails.calculation_details.map((tcItem, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td className=" text-right">{parseFloat(tcItem.affiliate_fields[0].field_rate).toFixed(2)}</td>
                                                                <td className=" text-right">{tcSnglFldShowCalcField ? <>{tcSnglFldCalcFieldValue==='staffCount' ? tcItem.staff_per_vehicle : tcSnglFldCalcFieldValue}</> :  <></>}</td>
                                                                <td className=" text-right">{tcItem.no_of_vehicles}</td>
                                                                <td className=" text-right">{parseFloat(tcItem.cost).toFixed(2)}</td>
                                                            </tr>))
                                                        }
                                                        <tr className="head">
                                                            <td colSpan={travelCostDetails.travel_fields.length + 3} className="text-left text-bold">
                                                                <div className="">{LBL_TRAVEL_COST_TOTAL}:</div>
                                                            </td>
                                                            <td className="text-right width-20-percent text-bold">
                                                                <div className="">{parseFloat(travelCostDetails.total_travel_cost).toFixed(2)}</div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between bgWhite font-14" >
                                            <div className="text-bold">{LBL_SHIFT_TOTAL}:</div>
                                            <div className="text-bold">{userCurrency + " "}{(parseFloat(item.shift_total)).toFixed(2)}</div>
                                            </div>
                                        </> 
                                        : 
                                        <>
                                            <div className="row preview-quote bgWhite border-TopBottom" >
                                                <table className="table mt-3 bgWhite" style={{ width: '100%'}}>
                                                    <thead className="bgWhite">
                                                        <tr className="bgWhite">
                                                            <th colSpan={2} className="bgWhite">
                                                                <div className='d-flex justify-content-between align-items-center w-100 font-14 margin-left-7'>
                                                                    <div className='text-bold'>{LBL_TRAVEL_COST} {travelCostDetails.travel_return_cost_included ? LBL_RETURN_COST_INCLUDED : ''} </div>
                                                                    {!tcMultiFldShowTravelDistance ? <div className='text-normal'>{LBL_DISTANCE_TO_LOCATION}: {parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)} {LBL_MILES}</div> : null}
                                                                    {!tcMultiFldShowTravelTime ? <div className='text-normal'>{LBL_TRAVEL_TIME}: {this.formatDecimalToHHMM(travelCostDetails.travel_duration_hh_mm)} {" (" +LBL_HOURS_SHORT +":" +LBL_MINS_SHORT +")"}  </div> : null}
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="bgWhite">
                                                            <td  colSpan={2} className='bgWhite' >
                                                                {travelCostDetails.calculation_details.map((tcItem, index) => (
                                                                <>
                                                                <table className="table bgWhite" style={{ width: '100%' }}>
                                                                    <thead className="bgWhite">
                                                                        <tr key={'row'+index.toString()} className="bgWhite">
                                                                            <th className="bgWhite">{LBL_TM_FIELD_NAME}</th>
                                                                            <th className="bgWhite text-right">{LBL_RATE}</th>
                                                                            {tcMultiFldShowTravelDistance ? <th className="bgWhite text-right">{LBL_DISTANCE} <span className='text-normal'>{' ('+LBL_MILES+')'}</span> </th>: null}
                                                                            {tcMultiFldShowTravelTime ? <th className="bgWhite text-right">{LBL_TRAVEL_TIME} <span className='bgWhite text-normal'>{' ('+LBL_HOURS_SHORT+')'}</span> </th>: null}
                                                                            {tcMultiFldShowNumPassenger ? <th className=" text-right">{LBL_NUM_PASSENGERS} </th>: null}
                                                                            <th className="bgWhite text-right">{LBL_NO_OF_VEHICLES}</th>
                                                                            <th className="bgWhite text-right">{LBL_TOTAL} ({userCurrency})</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="bgWhite">
                                                                    {tcItem.affiliate_fields.map(fieldItem => (
                                                                        <tr key={fieldItem.field_id}>
                                                                            <td>{this.getFieldName(travelCostDetails.travel_fields,fieldItem.field_id)}</td>
                                                                            <td className=" text-right">{parseFloat(fieldItem.field_rate).toFixed(2)}</td>
                                                                            {Number(fieldItem.field_type)===TM_FIELD_DISTANCE_ID ? <>
                                                                                <td className=" text-right">{parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)}</td>
                                                                                {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null }
                                                                                {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null }
                                                                            </> : 
                                                                                Number(fieldItem.field_type)===TM_FIELD_TIME_ID ? <>
                                                                                    {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null }
                                                                                    <td className=" text-right">{parseFloat(travelCostDetails.travel_duration_hh_mm).toFixed(2)}</td> 
                                                                                    {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null }
                                                                                </> : 
                                                                                    Number(fieldItem.field_type)===TM_FIELD_PSNGR_COUNT_ID ? <>
                                                                                    {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null }
                                                                                    {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null }
                                                                                    <td className=" text-right">{tcItem?.staff_per_vehicle}</td>
                                                                                    </> : 
                                                                                        Number(fieldItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID ? <>
                                                                                            {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null }
                                                                                            {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null }
                                                                                            {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null }
                                                                                        </> :
                                                                            <></>  
                                                                            }
                                                                            <td className=" text-right">{tcItem.no_of_vehicles}</td>
                                                                            <td className=" text-right">{parseFloat(fieldItem.field_total).toFixed(2)}</td>
                                                                        </tr> 
                                                                    ))} 
                                                                    <tr className="head">
                                                                        <td colSpan={(tcMultiColSpanValue+3)} className="text-bold text-left"> 
                                                                            {LBL_SUB_TOTAL}  
                                                                        </td>
                                                                        <td className="text-bold text-right"> 
                                                                            {parseFloat(tcItem.cost).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                </table>
                                                                </>))
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr className="head">
                                                            <td className="text-bold text-left">
                                                                <div className="margin-left-7">{LBL_TRAVEL_COST_TOTAL}:</div>
                                                            </td>
                                                            <td className="text-bold text-right width-20-percent">
                                                                <div className="margin-right-8">{parseFloat(travelCostDetails.total_travel_cost).toFixed(2)}</div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between bgWhite font-14" >
                                                <div className="text-bold">{LBL_SHIFT_TOTAL}: </div>
                                                <div className="text-bold">{userCurrency + " "}{(parseFloat(item.shift_total)).toFixed(2)}</div>
                                            </div>

                                            {/* <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between" style={{ background: "white",fontSize:'15px' }}>
                                                <div className="text-bold">{LBL_TRAVEL_COST}</div>
                                                <div>{LBL_DISTANCE_TO_LOCATION}: <span className="text-bold">{item.travel_cost_details?.travel_distance_miles} {LBL_MILES}</span></div>
                                                <div>{LBL_TRAVEL_TIME}: <span className="text-bold">{item.travel_cost_details?.travel_duration_hh_mm} Hrs</span></div>
                                            </div>


                                            <div className="row " style={{ background: "white" }}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr className="border-bottom " style={{ fontSize:'15px'}}>
                                                            <th>#</th>
                                                            {item.travel_cost_details.travel_fields.map(field => (
                                                                <th key={field.field_id} className="text-right">{field.field_name}</th>
                                                            ))}
                                                            <th className="text-right">{LBL_STAFF_PER_VEHICLE}</th>
                                                            <th className="text-right">{LBL_NO_OF_VEHICLES}</th>
                                                            <th className="text-right">{LBL_TOTAL}</th>
                                                        </tr>

                                                        {item.travel_cost_details.calculation_details.map((calcItem, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                {item.travel_cost_details.travel_fields.map(field => (
                                                                    <td key={field.field_id} className="text-right">
                                                                        {this.getFieldRate(calcItem.affiliate_fields, field.field_id)}
                                                                    </td>
                                                                ))}
                                                                <td className="text-right">{calcItem.staff_per_vehicle}</td>
                                                                <td className="text-right">{calcItem.no_of_vehicles}</td>
                                                                <td className="text-right">{userCurrency + " "}{calcItem.cost.toFixed(2)}</td>
                                                            </tr>
                                                        ))}
                                                                                                                <tr>
                                                            <td scope="row" colSpan={item.travel_cost_details.travel_fields.length + 3}  className="total pl-3 text-bold text-left">
                                                                <span className="text-bold">{LBL_TRAVEL_COST_TOTAL}:</span>
                                                            </td>
                                                            <td className="total text-right  text-bold">
                                                                <span className="text-bold">
                                                                    {userCurrency + " " + item.travel_cost_details?.total_travel_cost.toFixed(2)}
                                                                </span>
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between" style={{ background: "white" }}>
                                                <div className="text-bold">Shift Total:</div>

                                                <div className="text-bold">{userCurrency + " "}{(parseFloat(item.shift_total)).toFixed(2)}</div>
                                            </div> */}
                                        </>
                                        }

                                        </>
                                    )}

                                </React.Fragment>
                            )
                        })
                        }
                        <div className="row  preview-quote mt-10 border-TopBottom">
                            <table className="table">
                                <tbody>
                                    {this.props.additionalValues.length > 0 &&
                                        this.props.additionalValues.map((item, index) => {
                                            let discount = '';
                                            if (item.type === 'discount') discount = '-';
                                            return (
                                                <tr>
                                                    <td scope="row" colSpan="3" className="total pl-3 text-bold text-left"><span className="">{item.description}</span></td>
                                                    <td className="total text-right  text-bold"><span className="">{discount}{userCurrency} {parseFloat(Number(item.amount)).toFixed(2)}</span></td>
                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div className="row mt-20">
                            <div className="col-6 text-left text-bold">
                                {signature &&
                                    <p className="pb-2 pr-2">For {clientName}</p>}
                                {signature && <img alt="company-logo" src={signature} className='img-fliud' style={{ maxHeight: '150px' }} />}
                            </div>
                            <div className="col-6 text-right  text-bold">
                                <p className="pb-2 pr-2">{LBL_SUB_TOTAL} &emsp; {userCurrency + ' ' + subTotal}</p>
                                {parseFloat(discountCost) > 0 && <p className="pb-2 pr-2">
                                    {LBL_DISCOUNT}
                                    {quoteDiscountType && quoteDiscountType == DISCOUNT_TYPE_PERCENTAGE ? ' (' + quoteDiscountPerc + '%)' : ''}
                                    &emsp; &emsp; {'- ' + userCurrency + discountCost}</p>}
                                <p className="pb-2 pr-2">{LBL_VAT} &emsp; &emsp; {userCurrency + ' ' + vatCost}</p>
                                <p className="pb-2 pr-2"><big>{LBL_TOTAL} &emsp; {userCurrency + ' ' + overallTotal}</big></p>
                            </div>
                        </div>
                        <div className="row mt-20">
                            <div className="col-6">
                                {affDynamicFields.length > 0 && <p className="text-bold">{LBL_BANK_ACC_DET}</p>}
                                {affDynamicFields.map((item, inx) => {
                                    if ((item.value) && item.value.trim()) {
                                        return (
                                            <React.Fragment key={inx}>
                                                <p>{item.field_name}  : {item.value}</p>
                                            </React.Fragment>
                                        );
                                    } else {
                                        return (<></>)
                                    }
                                })
                                }
                            </div>
                            <div className="col-6 text-left">
                                <p>&nbsp;</p>
                                {/*<p className="pr-2">{affAdditionalText}</p>*/}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="preview-quote row mt-20">
                        <div className="col-12">
                            <p className=" text-center">
                                {affCompanyPhone !== '' &&
                                    <><i className="las la-phone"></i> {affCompanyPhone}  &emsp; </>
                                }
                                {affCompanyWebsite !== '' &&
                                    <><i className="las la-globe"></i> {affCompanyWebsite} &emsp; </>
                                }
                                {affCompanyEmail !== '' &&
                                    <><i className="las la-envelope"></i> {affCompanyEmail}   </>
                                }
                            </p>
                            <p>{affLocation}</p>
                        </div>
                    </Modal.Footer>
                </Modal>

                <ModalWindow ref={this.modalConfirmation} header={LBL_CONFIM_TO_REGEN_INVOICE} type="confirm" deleteConfirmedItem={this.sendInvoice} resetModalForm={this.onModalFormReset} >
                    {MSG_CONFIRM_REGEN_INVOICE}
                </ModalWindow>
            </React.Fragment>
        )
    }

}
export default PreviewInvoice;